import { useQuery } from 'react-query'
import { getTasks } from '../../api/tasks'

export function useTasksQuery(jobnumber) {
  const id = jobnumber ? jobnumber.id : null
  const enabled = !!id
  return useQuery(['tasks', id], () => getTasks(id), { enabled: enabled })
}
